import styled from 'styled-components'

export const ActionsCell = styled.div`
	flex: 1;
	width: 16px;
	display: flex;
	align-items: center;
`
